import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const addService = async (placeId, serviceId, update) => {
  if (!placeId || !update || !serviceId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/services/${serviceId}/add`,
    data: { values: update },
  });
};